"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsHasFingerPrinterStatus = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _Fingerprint = _interopRequireDefault(require("@mui/icons-material/Fingerprint"));
var _DmsFetch = require("../DmsFetch/DmsFetch");
var _HttpStatus = require("../../constants/HttpStatus");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const DmsHasFingerPrinterStatus = _ref => {
  let {
    row,
    token
  } = _ref;
  const [userHasFingerPrinter, setUserHasFingerPrinter] = (0, _react.useState)(null);
  const [status, setStatus] = (0, _react.useState)("loading");
  (0, _react.useEffect)(() => {
    const fetchUserData = async () => {
      try {
        const data = await (0, _DmsFetch.fetchData)("finger_printer/dms/get_user_by_user_pk/".concat(row.pk), "GET", token);
        setUserHasFingerPrinter(data);
        if (data.status == _HttpStatus.HTTP_STATUS.OK_200) {
          setStatus("success");
        } else if (data.status == _HttpStatus.HTTP_STATUS.NOT_FOUND_404) {
          setStatus("not_found");
        } else {
          setStatus("error");
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setStatus("not_found");
        } else {
          setStatus("error");
        }
      }
    };
    fetchUserData();
  }, [row.pk, token]);
  const getChipProperties = () => {
    switch (status) {
      case "success":
        return {
          label: _reactIntlUniversal.default.get("FingerprintFound").d("Fingerprint Found"),
          color: "success",
          icon: /*#__PURE__*/_react.default.createElement(_Fingerprint.default, null)
        };
      case "not_found":
        return {
          label: _reactIntlUniversal.default.get("FingerprintNotFound").d("Fingerprint Not Found"),
          color: "error",
          icon: /*#__PURE__*/_react.default.createElement(_Fingerprint.default, null)
        };
      case "error":
        return {
          label: _reactIntlUniversal.default.get("ErrorFetchinData").d("Error Fetching Data"),
          color: "warning",
          icon: /*#__PURE__*/_react.default.createElement(_Fingerprint.default, null)
        };
      default:
        return {
          label: _reactIntlUniversal.default.get("Loading").d("Loading..."),
          color: "default"
        };
    }
  };
  const chipProps = getChipProperties();
  return /*#__PURE__*/_react.default.createElement(_material.Chip, _extends({}, chipProps, {
    variant: "outlined"
  }));
};
exports.DmsHasFingerPrinterStatus = DmsHasFingerPrinterStatus;
DmsHasFingerPrinterStatus.propTypes = {
  row: _propTypes.default.object.isRequired,
  token: _propTypes.default.string.isRequired
};